<template>
    <div>
        <el-button @click="view" type="primary" size="small" v-text="text"></el-button>
        <el-dialog :title="reply.state===0?'留言回复':'留言回复（已回复）'" :visible.sync="dialogFormVisible">
            <el-form :model="reply">
                <el-form-item label="内容" label-width="60px">
                    <el-input
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 4}"
                            placeholder="请输入内容"
                            v-model="reply.text">
                    </el-input>
                </el-form-item>
                <el-form-item label="时间" label-width="60px">
                    <el-date-picker
                            v-model="reply.time"
                            :picker-options="dateTimeRangeOptions"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" v-if="reply.state===1" @click="delReply">删 除</el-button>
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitReply">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    export default {
        name: "gbookReply",
        data() {
            return {
                dayjs,
                dialogFormVisible: false,
                reply: {
                    url: 'add.php',
                    state: 0,
                    id: '',
                    gid: '',
                    mail: this.row.mail,
                    time: function () {
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000);
                        return dayjs(start).format('YYYY-M-D')
                    }(),
                    text: '',
                    action: 'addGbookRe'
                },
                dateTimeRangeOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                }
            }
        },
        props: {
            text: {},
            row: {},
        },
        methods: {
            delReply(){
                this.$request({
                    url:'del.php',
                    method:'post',
                    data:{
                        action:'delGbookRe',
                        id:this.reply.id,
                        gid:this.reply.gid,
                    }
                }).then(res=>{
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.dialogFormVisible=false
                }).catch(err=>{
                    this.$message.error( '错误');
                })
            },
            submitReply() {
                this.dialogFormVisible = false
                console.log(this.reply)
                // return
                this.$request({url: this.reply.url, method: 'post', data: this.reply}).then(res => {
                    if(this.reply.state===0){
                        this.$message({
                            message: '回复成功',
                            type: 'success'
                        });
                    }else if(this.reply.state===1){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                    }else {
                        this.$message.error( 'what the fuck');
                    }
                }).catch(() => {
                })
            },
            view() {
                this.reply.id = this.row.id
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$request({
                    url: 'list.php',
                    method: 'post',
                    data: {action: 'getReplyByID', id: this.row.id}
                }).then(res => {
                    if (res) {
                        this.reply = res
                        this.reply.url='change.php'
                        this.reply.state = 1
                        this.reply.action= 'changeGbookReById'
                    }
                    this.reply.gid=this.row.id
                    this.dialogFormVisible = true
                    loading.close()
                }).catch(err => {
                    this.$message({
                        message: '加载失败，请重试',
                        type: 'warning'
                    });
                    loading.close()
                })

                // this.$store.dispatch('d2admin/page/open', {
                //     name: 'heannyByUrl',
                // })
                // location.href = '/#/heanny/'+encodeURIComponent('www.heanny.cn/post-' + this.row.id+'.html')
            }
        },
    }
</script>

<style scoped>

</style>
